import React from "react";
import NewsletterTwentyTwo from "../component/NewsletterTwentyTwo";

function NewsletterTwentyTwoContainer() {
  return <NewsletterTwentyTwo />;
}

export default NewsletterTwentyTwoContainer;
